import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useActions, useValues } from 'kea'
import ReactImages from 'react-images'

import lightboxLogic from './logic'

const Lightbox = ({ user }) => {
  const logic = lightboxLogic({ user })

  const { isLightboxOpen, lightBoxPhotos, currentImage } = useValues(logic)
  const { nextImage, previousImage, setCurrentImage, closeLightBox, setDimensions } = useActions(logic)

  const updateDimensions = useCallback(() => {
    setDimensions(window.innerWidth, window.innerHeight)
  }, [setDimensions])

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    updateDimensions()

    return () => {
      window.removeEventListener('resize', updateDimensions)
    }
  }, [updateDimensions])

  return (
    <ReactImages
      images={lightBoxPhotos}
      isOpen={isLightboxOpen}
      currentImage={currentImage}
      onClickPrev={previousImage}
      onClickNext={nextImage}
      onClickThumbnail={setCurrentImage}
      onClose={closeLightBox}
      backdropClosesModal
      showThumbnails
    />
  )
}

Lightbox.propTypes = {
  user: PropTypes.object.isRequired
}

export default Lightbox
